import {PatientNotes} from '../../patient/components/models/patient-note';
import {axiosDeleteHelper} from '../../shared/service/axios-delete-helper';
import {AxiosDeletePayload} from '../../shared/service/axios-delete-payload';
import {
  AxiosResultDeleteStatus,
} from '../../shared/service/axios-result-delete-status';
import {AxiosResultStatus} from '../../shared/service/axios-result-status';
import {axiosSaveHelper} from '../../shared/service/axios-save-helper';
import {AxiosSavePayload} from '../../shared/service/axios-save-payload';
import _ from 'lodash';

export class CommentsService {


  async deletePatientNote(noteToDelete: Partial<PatientNotes>, commentId: number): Promise<AxiosResultStatus> {
    const readPayload: AxiosSavePayload = {
      dataToSave: noteToDelete,
      dataId: commentId,
      url: `patient-encounter/v2/note/${commentId}`,
      isPatch: true,
    }
    return await axiosSaveHelper(readPayload);
  }

  async dismissReminder(reminderToRemove: Partial<PatientNotes>, commentId: number):Promise<AxiosResultStatus> {
    const payload: AxiosSavePayload = {
      dataToSave: _.omit(reminderToRemove, ['patientNotesId']),
      dataId: commentId,
      url: `patient-encounter/v2/note/${commentId}`,
      isPatch: true
    }
    return await axiosSaveHelper(payload);
  }

  async deleteClientComment(clientId: number, commentId:number): Promise<AxiosResultDeleteStatus> {
    const readPayload: AxiosDeletePayload = {
      dataId: commentId,
      url: `client/${clientId}/comment`
    }
    const responseData = await axiosDeleteHelper(readPayload);
    return responseData;
  }
}

export const commentsService = new CommentsService();